import includes from "lodash/includes";
import uniq from "lodash/uniq";
import { createSelector } from "reselect";
import { assetDetailSelector } from "selectors/asset";
import { currentUserCompanySelector } from "selectors/currentUser";
import { dealPortfolioSelector } from "selectors/deal";
import {
  isAssetDetail as isAssetDetailSelector,
  isDealDetail as isDealDetailSelector,
} from "selectors/location";
import { selectedPortfoliosSelector } from "selectors/portfolio";

export const limitiationsSelector = createSelector(
  isAssetDetailSelector,
  isDealDetailSelector,
  assetDetailSelector,
  dealPortfolioSelector,
  currentUserCompanySelector,

  selectedPortfoliosSelector,
  (isAssetDetail, isDealDetail, asset, dealPortfolio, company, portfolios) => {
    const companyLimitations = company && company.limitations ? company.limitations : [];

    if (isAssetDetail && asset) {
      return uniq([...companyLimitations, ...asset.portfolio.limitations]);
    }

    if (isDealDetail && asset) {
      return uniq([...companyLimitations, ...dealPortfolio.limitations]);
    }

    return uniq(
      portfolios.reduce(
        (limitations, portfolio) => [...limitations, ...portfolio.limitations],
        companyLimitations
      )
    );
  }
);

export const isDealsPermitted = createSelector(
  limitiationsSelector,
  (limitations) => !includes(limitations, "deals")
);

export const isAssetDealsEnabled = createSelector(
  limitiationsSelector,
  (limitations) => includes(limitations, "asset_deals") === false
);

export default limitiationsSelector;
